<!-- 复制 + 复制后弹框信息 -->
<template>
  <i
    :style="styleData"
    :class="iconClass"
    v-clipboard:copy="copyData"
    v-clipboard:success="copySuccess"
    v-clipboard:error="copyError"
  ></i>
</template>

<script>
export default {
  name: "ClipboardIcon",
  props: {
    styleData: {    //  普通样式
      type: String,
      default: 'padding-left:6px; cursor: pointer;'
    },
    iconClass: {      //  图标样式
      type: String,
      default: 'el-icon-document-copy'
    },
    copyData: {     //  复制内容
      type: String,
      default: ''
    },
    successTitle: { //  复制成功弹框内容
      type: String,
      default: '复制成功！'
    },
    errorTitle: {   //  复制失败弹框内容
      type: String,
      default: '复制失败！'
    },
  },
  data() {
    return {

    }
  },
  methods: {
    /**
     * 复制成功，弹框信息
     */
    copySuccess() {
      this.$message({
        message: this.successTitle,
        type: 'success'
      });
    },
    /**
     * 复制失败，弹框信息
     */
    copyError() {
      this.$message({
        message: this.errorTitle,
        type: 'error'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
</style>